import { env } from "../datas.config";

export const createAccount = (values, setResponseCreateAccount) => {
  fetch(`${env.domain}/api/visitor/signup`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    method: "post",
    body: JSON.stringify({ ...values }),
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      console.clear();
      console.log(data);
      setResponseCreateAccount(data);
    })
    .catch((erreur) => {
      console.clear();
      console.error(erreur);
      setResponseCreateAccount(erreur);
    });
};

export const getUsers = async (values, setUsers) => {
  try {
    const options = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      method: "get",
      credentials: "include",
    };
    const res = await fetch(`${env.domain}/api/auth/get-users/users`, options);
    const users = await res.json();
    setUsers(users.contacts);
    console.clear();
  } catch (err) {
    console.clear();
    console.error(`Une erreur est survenue ${err.toString()}`);
  }
};
